import React, { useEffect } from 'react';
import { useFormik } from "formik";
import { useState } from "react";
import jsPDF from 'jspdf';


function Builder() {
    const [image, setImage]: any = useState(null);
    const [currencies, setCurrencies]: any = useState([]);
    const templateForm = useFormik({
        initialValues: {
            logo: '',
            title: 'INVOICE123',
            invoiceNumber: '',
            issueDate: '',
            dueDate: '',
            companyDetails: '',
            billTo: '',
            tax: 0,
            discount: 0,
            total: 0,
            notes: '',
            currency: 'USD',
            // bankAccountDetails: '',
            items: [
                { desc: "", qty: 0, unitCost: 0, amount: 0 },
                { desc: "", qty: 0, unitCost: 0, amount: 0 },
            ]
        },
        onSubmit: (values) => {
            onGeneratePdf(values)
        },

    })

    useEffect(() => {
        getCurrencies()
    }, [])

    const getCurrencies = async () => {
        try {
            const response = await fetch('/data/currencies.json')
            const currencies = await response.json()
            setCurrencies(currencies.data)
        } catch (error) {

        }
    }

    const onAddItem = () => {
        templateForm.setFieldValue('items', [...templateForm.values.items, { desc: "", qty: 0, unitCost: 0, amount: 0 }]);
    }

    const onDeleteItem = (index: number) => {
        templateForm.setFieldValue('items', templateForm.values.items.filter((item, i) => i !== index))
    }

    const onLogoChange = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                setImage(e.target.result);
            };
            reader.readAsDataURL(file);
        }


    }

    const onLogoClear = () => {
        setImage(null);
    }

    const onApplyTax = (event: any) => {
        const total = templateForm.values.total;
        const taxValue = event.target.value * total / 100
        templateForm.setFieldValue("total", total - taxValue);
        templateForm.handleChange(event);
    }

    const onApplyDiscount = (event: any) => {
        templateForm.handleChange(event);
        const total = templateForm.values.total;
        const discountValue = event.target.value * total / 100
        templateForm.setFieldValue("total", total - discountValue);
    }

    const getItemsTotal = () => {
        templateForm.setFieldValue("total", templateForm.values.items.reduce((a: any, b: any) => a + b.amount, 0));
    }

    const getItemTotal = (event: any, index: number, control: string) => {
        if (control === 'qty') {
            templateForm.values.items[index] = { ...templateForm.values.items[index], amount: event.target.value * templateForm.values.items[index].unitCost };
        } else {
            templateForm.values.items[index] = { ...templateForm.values.items[index], amount: templateForm.values.items[index].qty * event.target.value };
        }
        templateForm.handleChange(event);
        getItemsTotal();
    }

    const onGeneratePdf = (values: any) => {
        fetch('/templates/template.html').then((result: any) => {
            return result.text();
        }).then(page => {
            const element = document.createElement("div")
            element.innerHTML = page
            Object.keys(values).forEach(item => {
                const x = element.querySelector('#' + item)
                // table values
                if (item === 'items') {
                    values[item].forEach((y: any, index: number) => {
                        const tr = document.createElement('tr');
                        Object.values(y).forEach(a => {
                            const td: any = document.createElement('td');
                            td.innerText = a
                            tr.appendChild(td)
                        })
                        element.querySelector('#table')?.appendChild(tr)
                    });
                    // Tax row
                    const taxTr = document.createElement('tr');
                    const taxTd: any = document.createElement('td');
                    taxTd.setAttribute('colspan', '4')
                    taxTd.innerText = 'TAX: ' + templateForm.values.tax + ' ' + '%'
                    taxTd.style.textAlign = 'end'
                    taxTr.appendChild(taxTd)
                    element.querySelector('#table')?.appendChild(taxTr)
                    // Discount row
                    const discountTr = document.createElement('tr');
                    const discountTd: any = document.createElement('td');
                    discountTd.setAttribute('colspan', '4')
                    discountTd.innerText = 'Discount: ' + templateForm.values.discount + ' ' + '%'
                    discountTd.style.textAlign = 'end'
                    discountTr.appendChild(discountTd)
                    element.querySelector('#table')?.appendChild(discountTr)
                    // Total row
                    const totalTr = document.createElement('tr');
                    const totalTd: any = document.createElement('td');
                    totalTd.setAttribute('colspan', '4')
                    totalTd.innerText = 'Total: ' + templateForm.values.total + ' ' + templateForm.values.currency
                    totalTd.style.textAlign = 'end'
                    totalTr.appendChild(totalTd)
                    element.querySelector('#table')?.appendChild(totalTr)
                }
                if (x) {
                    // Span values
                    if (x.localName === 'span') {
                        x.textContent = values[item]
                    }
                    // img values
                    if (x.localName === 'img') {
                        x.setAttribute('src', image)
                    }
                }
            })
            const doc = new jsPDF('p', 'px', 'a4');
            doc.html(element, {
                async callback(doc) {
                    await doc.save(templateForm.values.title);
                },
                width: 450, //target width in the PDF document
                windowWidth: 650 //window width in CSS pixels
            });
        })


    }



    return <div className='builder-container'>
        <div className="col-1">
            <header>
                <a href="" className="logo">
                    <img src="/images/logo.svg" alt="" />
                </a>
            </header>
            <ul>
                <li><a href=""><i className='bx bx-envelope'></i></a></li>
                <li><a href=""><i className='bx bx-info-circle' ></i></a></li>
            </ul>
        </div>
        <div className="col-2">
            <header>
                <h3>Invoice Configuration</h3>
            </header>
            <div className="config">
                <div className="form-group">
                    <div className="form-group">
                        <label htmlFor="title">Title</label>
                        <input id="title" name="title" onChange={templateForm.handleChange} value={templateForm.values.title} type="text" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="currency">Currency</label>
                        <select onChange={templateForm.handleChange} value={templateForm.values.currency} name="currency" id="currency">
                            {currencies.length && currencies.map((item: any, index: number) => (
                                <option key={index} value={item.code}>{item.code}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="tax">TAX</label>
                        <div className="control">
                            <input onChange={(e) => onApplyTax(e)} value={templateForm.values.tax} id="tax" type="number" />
                            <span>%</span>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="discount">Discount</label>
                        <div className="control">
                            <input onChange={(e) => onApplyDiscount(e)} value={templateForm.values.discount} id="discount" type="number" />
                            <span>%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form className="col-3" onSubmit={templateForm.handleSubmit}>
            <header>
                <h3>{templateForm.values.title}</h3>
                <div className='actions'>
                    <a href="https://www.buymeacoffee.com/zakariaatattou" target="_blank"><button type='button' className='btn btn-primary-outline'>  <i className='bx bx-coffee-togo'></i> Support</button></a>
                    <button type='submit' className='btn btn-primary'><i className='bx bx-cloud-download' ></i>  Generate</button>
                </div>
            </header>
            <div className="template">
                <div className="builder">
                    {/* <img className="dot-grid-1" src="/images/dot-grid.svg" alt="" /> */}
                    <div className="logo">
                        <label htmlFor="file-input" className="file-control">
                            <input name="logo" onChange={(e) => onLogoChange(e)} value={templateForm.values.logo} type="file" id="file-input" />
                            <i className='bx bx-cloud-upload'></i>
                            <p>Click to upload or Drag and drop</p>
                            <span>SVG, PNG, JPG or GIF (MAX. 800x400px)</span>
                        </label>

                        {image && <div className="uploaded-img"><img src={image} alt="Uploaded" /> <button onClick={onLogoClear}><i className='bx bx-x'></i></button></div>}
                    </div>




                    <div className="flex">
                        <div className="form-group">
                            <label htmlFor="invoiceNumber">Invoice No.</label>
                            <input placeholder='123' id="invoiceNumber" name="invoiceNumber" onChange={templateForm.handleChange} value={templateForm.values.invoiceNumber} type="text" />
                        </div>

                        <div className="form-group">
                            <label htmlFor="issueDate">Issue Date</label>
                            <input id="issueDate" name="issueDate" onChange={templateForm.handleChange} value={templateForm.values.issueDate} type="date" />
                        </div>

                        <div className="form-group">
                            <label htmlFor="dueDate">Due Date</label>
                            <input id="dueDate" onChange={templateForm.handleChange} value={templateForm.values.dueDate} type="date" />
                        </div>
                    </div>

                    <div className="flex">
                        <div className="form-group">
                            <label htmlFor="companyDetails">Company Details</label>
                            <textarea placeholder='Sparksuite, Inc.
12345 Sunny Road
Sunnyville, CA 12345' onChange={templateForm.handleChange} value={templateForm.values.companyDetails} name="companyDetails" id="companyDetails" cols={30} rows={10}></textarea>
                        </div>

                        <div className="form-group">
                            <label htmlFor="billTo">Bill To</label>
                            <textarea placeholder='Acme Corp.
John Doe
john@example.com' onChange={templateForm.handleChange} value={templateForm.values.billTo} name="billTo" id="billTo" cols={30} rows={10}></textarea>
                        </div>
                    </div>

                    <div className="items">
                        {templateForm.values.items.length && templateForm.values.items.map((item, index) => (
                            <div className="item" key={index}>
                                <div className="form-group description">
                                    <label htmlFor={`items[${index}].desc`}>Item description</label>
                                    <textarea
                                        onChange={templateForm.handleChange}
                                        value={item.desc}
                                        name={`items[${index}].desc`}
                                        id={`items[${index}].desc`}
                                        cols={20}
                                        rows={5}>
                                    </textarea>
                                </div>
                                <div className="form-group quantity">
                                    <label htmlFor={`items[${index}].qty`}>Quantity</label>
                                    <input
                                        onChange={(e) => getItemTotal(e, index, 'qty')}
                                        value={item.qty}
                                        name={`items[${index}].qty`}
                                        id={`items[${index}].qty`}
                                        type="number"
                                    />
                                </div>
                                <div className="form-group cost">
                                    <label htmlFor={`items[${index}].unitCost`}>Unit Cost</label>
                                    <div className="control">
                                        <input
                                            onChange={(e) => getItemTotal(e, index, 'unitCost')}
                                            value={item.unitCost}
                                            name={`items[${index}].unitCost`}
                                            id={`items[${index}].unitCost`}
                                            type="number"
                                        />
                                        <span>{templateForm.values.currency}</span>
                                    </div>
                                </div>
                                <div className="form-group amount">
                                    <label htmlFor={`items[${index}].amount`}>Amount</label>
                                    <div className="control">
                                        <input
                                            readOnly
                                            onChange={templateForm.handleChange}
                                            value={item.amount}
                                            name={`items[${index}].amount`}
                                            id={`items[${index}].amount`} type="number"
                                        />
                                        <span>{templateForm.values.currency}</span>

                                    </div>
                                </div>
                                <div className="actions">
                                    {/* <button type="button" disabled={templateForm.values.items.length == 1} className="grey"><i className='bx bx-move' ></i></button> */}
                                    <button type="button" disabled={templateForm.values.items.length == 1} className="danger" onClick={() => onDeleteItem(index)}><i className='bx bx-minus-circle' ></i></button>
                                </div>
                            </div>
                        ))}
                        <div className="actions">
                            <button type='button' className="btn btn-primary" disabled={templateForm.values.items.length > 6 || templateForm.values.items.length == 1} onClick={onAddItem}><i className='bx bx-plus-circle'></i></button>
                        </div>
                    </div>

                    <div className="flex totals">
                        <div className="form-group">
                            <label htmlFor="total">Total</label>
                            <div className="control">
                                <input onChange={templateForm.handleChange} value={templateForm.values.total} id="total" readOnly type="number" />
                                <span>{templateForm.values.currency}</span>
                            </div>
                        </div>
                    </div>

                    <div className="flex">
                        <div className="form-group">
                            <label htmlFor="notes">Terms & Conditions</label>
                            <textarea onChange={templateForm.handleChange} value={templateForm.values.notes} name="notes" id="notes" cols={30} rows={10}></textarea>
                        </div>
                        {/* 
                        <div className="form-group">
                            <label htmlFor="bankAccountDetails">Bank account details</label>
                            <textarea onChange={templateForm.handleChange} value={templateForm.values.bankAccountDetails} name="bankAccountDetails" id="bankAccountDetails" cols={30} rows={10}></textarea>
                        </div> */}
                    </div>

                    {/* <button type="submit" className="btn btn-primary generate-btn"><i className='bx bx-cloud-download' ></i> Generate </button> */}
                </div>
            </div>
        </form>
    </div>
}

export default Builder;

